import React, { useState, useEffect } from 'react';
import apiService from '../../services/api'; // Assuming default export

const ReviewPromptEditor = ({ token }) => {
  const [prompt, setPrompt] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Fetch the current prompt on load
  const fetchPrompt = async () => {
    if (!token) return;
    setIsLoading(true);
    setError('');
    try {
      const data = await apiService.getReviewPrompt(token); // Needs to be added to api.js
      setPrompt(data.prompt || '');
    } catch (err) {
      setError('Failed to load the review prompt.');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPrompt();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const handleChange = (e) => {
    setPrompt(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setSuccess('');

    if (!prompt.trim()) {
        setError('Prompt content cannot be empty.');
        setIsLoading(false);
        return;
    }

    try {
      const response = await apiService.updateReviewPrompt({ prompt }, token); // Needs to be added to api.js
      setSuccess(response.msg || 'Review prompt updated successfully!');
    } catch (err) {
      setError(err.response?.data?.msg || err.message || 'Failed to save review prompt.');
      console.error(err);
    } finally {
      setIsLoading(false);
      // Optionally clear success message after a few seconds
      setTimeout(() => setSuccess(''), 5000);
    }
  };

  return (
    <div>
      <h3>Review Prompt Editor</h3>
      <p>Edit the system prompt used by the AI to generate performance reviews for simulation transcripts.</p>
      <p>Use placeholders like <code>{"{{therapistPersonaKey}}"}</code>, <code>{"{{clientPersonaKey}}"}</code>, and <code>{"{{formattedTranscript}}"}</code> where dynamic content should be inserted.</p>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '10px' }}>
          <label htmlFor="review-prompt">Review System Prompt: </label>
          <textarea
            id="review-prompt"
            name="prompt"
            value={prompt}
            onChange={handleChange}
            disabled={isLoading}
            required
            rows="25" // Make it large
            style={{ width: '95%', display: 'block', fontFamily: 'monospace' }}
            placeholder="Enter the system prompt for the review AI..."
          />
        </div>

        {error && <p style={{ color: 'red' }}>{error}</p>}
        {success && <p style={{ color: 'green' }}>{success}</p>}

        <div style={{ marginTop: '15px' }}>
          <button type="submit" disabled={isLoading}>
            {isLoading ? 'Saving...' : 'Save Review Prompt'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ReviewPromptEditor;
